import React, { useEffect, useState } from "react";
import DashboardCountCard from "components/common/DashboardCountCard";

import { IoBusiness, IoPeople } from "react-icons/io5";
import { FaDumbbell, FaFlag, FaUser, FaSmile, FaCar } from "react-icons/fa";
import { LuBrain } from "react-icons/lu";
import { PiBowlFoodFill } from "react-icons/pi";
import axios from "axios";
import { GET_DASHBOARD_STATS } from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import DashboardReportTypeCard from "components/common/DashboardReportTypeCard";
import DashboardTopOrgsCard from "components/common/DashboardTopOrgsCard";
import DashboardMoodCard from "components/common/DashboardMoodCard";
import UpdateAdminUsersModal from "components/AppReports/Modals/UpdateAdminUsersModal";
import EventBus from "providers/EventBus";
import { useNavigate } from "react-router-dom";
import DashboardSplitCountCard from "components/common/DashboardSplitCountCard";

const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState([]);

  const [showAdminUsers, setShowAdminUsers] = useState(false);

  useEffect(() => {
    document.title = "Dashboard | Administration Panel | Mind Pulse";

    getDashboardStats();
  }, []);

  const getDashboardStats = async () => {
    const response = await axios.get(GET_DASHBOARD_STATS, {
      headers: generateURLOptions(),
    });

    console.log("Response is: ", response.data);

    if (response?.data?.success === false) {
      return alert(response?.data?.message ?? "");
    }

    setStats(response?.data?.data);
  };

  return (
    <>
      <UpdateAdminUsersModal
        isOpen={showAdminUsers}
        onClose={() => {
          setShowAdminUsers(false);
          getDashboardStats();
        }}
      />
      <div className="space-y-6 mt-24 px-8">
        {/* Top Section */}

        <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
          <div className="grid grid-cols-2 gap-4">
            <DashboardSplitCountCard
              icon={<IoBusiness className="text-white mr-2 text-lg" />}
              title={"Active Organisations/Groups"}
              count={stats?.companiesCount ?? 0}
              heartCount={stats?.companies?.filter(
                (company) => !company?.companyPlan
              )}
              coreCount={stats?.companies?.filter(
                (company) => company?.companyPlan?.name == "Mind Pulse Core"
              )}
              expandCount={stats?.companies?.filter(
                (company) => company?.companyPlan?.name == "Mind Pulse Expand"
              )}
              optimumCount={stats?.companies?.filter(
                (company) => company?.companyPlan?.name == "Mind Pulse Optimum"
              )}
            />

            <DashboardCountCard
              icon={<IoPeople className="text-white mr-2 text-lg" />}
              title={"Active Users"}
              count={stats?.usersCount ?? 0}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <DashboardCountCard
              icon={<FaDumbbell className="text-white mr-2 text-lg" />}
              title={"Active Exercise Routines"}
              count={stats?.exerciseCount ?? 0}
            />

            <DashboardCountCard
              icon={<PiBowlFoodFill className="text-white mr-2 text-lg" />}
              title={"Active Recipes"}
              count={stats?.recipeCount ?? 0}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <DashboardCountCard
              icon={<LuBrain className="text-white mr-2 text-lg" />}
              title={"Active Mindfulness Items"}
              count={stats?.mindfulnessCount ?? 0}
            />

            <DashboardCountCard
              icon={<FaCar className="text-white mr-2 text-lg" />}
              title={"Active Virtual Commute Items"}
              count={stats?.virtualCommuteCount ?? 0}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <DashboardCountCard
              icon={<FaUser className="text-white mr-2 text-lg" />}
              title={"Nominated Admins"}
              count={stats?.adminsCount ?? 0}
              onTap={() => setShowAdminUsers(true)}
              actionText={"Update Admin Users"}
            />

            <DashboardCountCard
              icon={<FaFlag className="text-white mr-2 text-lg" />}
              title={"App Reports"}
              backgroundColor="#ff0000"
              count={stats?.appReportsCount ?? 0}
              onTap={() => {
                navigate("/admin/app-reports");
                EventBus.emit("changeRoute", "App Reports");
              }}
              actionText={"View App Reports"}
            />
          </div>
        </div>

        <DashboardMoodCard
          icon={<FaSmile className="text-white mr-2 text-lg" />}
          title={"Platform Pulse"}
          items={stats?.moods ?? []}
        />

        <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
          <div>
            <DashboardTopOrgsCard
              icon={<IoBusiness className="text-white mr-2 text-lg" />}
              title={"Top Organisations/Groups"}
              count={stats?.companiesCount ?? 0}
              items={stats?.mostUsedOrgs ?? []}
            />
          </div>

          <div>
            <DashboardReportTypeCard
              icon={<FaFlag className="text-white mr-2 text-lg" />}
              title={"Common Report Type"}
              items={stats?.reportTypeCount ?? []}
              backgroundColor="#ff0000"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
